__turbopack_context__.v({
  "wrapper": "nlK1ta_wrapper",
});
